<app-header></app-header>

<div class="pitStop" id="desktop">
  <div class="pitStopImageContainer">
    <img src="../../assets/image/HL prepare/pitstop.png">
  </div>
  <div class="pitStopSearch">
    <h4>PITSTOP LOCATOR</h4>
    <form class="pitStopSearchBar" (submit)="pitstopLocator()">
      <input type="text" id="searchWord" placeholder="Enter a State, City or Postcode" [(ngModel)]="searchWord" [(value)]="searchWord" name="searchWord" >
      <input type="submit"   id="findNow" value="FIND NOW">
    </form>
  </div>
</div>

<div class="pitStop" id="mobile">
  <h4>PITSTOP LOCATOR</h4>
    <div class="pitStopImageContainer">
      <img src="../../assets/image/HL prepare/pitstop.png">
    </div>
    <div class="pitStopSearch">
      <form class="pitStopSearchBar" (submit)="pitstopLocator()">
        <input type="text" id="searchWord" placeholder="Enter a State, City or Postcode" [(ngModel)]="searchWord" [(value)]="searchWord" name="searchWord" >
        <input type="submit"   id="findNow" value="FIND NOW">
      </form>
    </div>
</div>

<div class="pitStopSearchResult">
    <div class="pit-container">
      <div class="paddingSection" *ngIf="paddingSetting"></div>
      <div *ngFor="let locator of branchLocator" class="pit-div">
        <div class="pit-name-container">
          <h3 class="pit-name" style="text-transform: uppercase;">{{locator.place}} ({{locator.branchcode}})</h3>
        </div>
        <div class="pit-detail">
          <div class="">
            <h4 class="pit-detail-title">Address</h4>
            <p class="pit-detail-content">{{locator.address}} {{locator.postcode}} {{locator.city}}, {{locator.state}}.</p>
            <h4 class="pit-detail-title">Service Provided</h4>
            <p class="pit-detail-content">{{locator.function}}</p>
          </div>
          <div class="">
            <h4 class="pit-detail-title">Email</h4>
            <p *ngFor="let sub_email of locator.picemail?.split(';')" class="pit-detail-content">{{sub_email}}</p>
            <h4 class="pit-detail-title">Contact Details</h4>
            <p *ngFor="let sub_phone of locator.phone?.split(';')" class="pit-detail-content">{{sub_phone}}</p>
          </div>
          <div class="">
            <h4 class="pit-detail-title">Operating Hours</h4>
            <p class="pit-detail-content">{{locator.operationhour.length >1 ? locator.operationhour:'8.00am-5.00pm'}}</p>
            <h4 class="pit-detail-title">Find Us</h4>
            <p class="pit-detail-content">
                <a href="waze://?ll={{locator.latitude}},{{locator.longtitude}}&amp;navigate=yes" style="text-decoration: none;">Waze</a>
                &nbsp;| 
                <a href="https://maps.google.com?q={{locator.longtitude}},{{locator.latitude}}" style="text-decoration: none;">Google Map</a>
            </p>
          </div>
        </div>
      </div>
      <div class="paddingSection" *ngIf="paddingSetting"></div>
  </div>

</div>
  
<app-footer></app-footer>